import "../home/style.scss";

import React from "react";

// import { UserGlobalContextMemorySpace } from "../../../contexts/user/userGlobalContext";
import { QuestionsContextMemorySpace } from "../../../contexts/questions/questionsContext";
import { Information } from "../../../components/common/information/information";
import WhatsappComponent from "../../../components/common/whatsapp";
import { useToggle } from "../../../utils/hooks/useToggle";
import { GrupoMenuComponent } from "../home/grupo-menu";
import { BuscadorComponent } from "../buscador-component";
import { fetchExternal } from "../../../utils/fetch";
import useSlide from "./hooks/useSlide";
import slide from "../../../assets/img/micrositio/background.webp";
import { useContext } from "react";

const HomeMicrositio = () => {
  const { question } = useContext(QuestionsContextMemorySpace);

  const [novedad, setNovedad] = React.useState(false);
  const [loader, setLoader] = React.useState(true);

  const [info, setInfo] = React.useState(null);
  const [pantalla,setPantalla]=React.useState(null);
  const informationToggle = useToggle();

  // const { slide } = useSlide();

  React.useEffect(() => {
    getInfo();
  }, []);

  function esMovil() {
    const esPorUserAgent = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const esPorTamanio = window.innerWidth <= 768;
    return esPorUserAgent || esPorTamanio;
}

window.addEventListener('resize', () => {
  // console.log(`Nuevo tamaño - Ancho: ${window.innerWidth}px, Alto: ${window.innerHeight}px`);
  setPantalla(window.innerWidth)
});

  const getInfo = async () => {
    try {
      const { data } = await fetchExternal(
        `${process.env.REACT_APP_STRAPI_QA}/pagina-principals?idEmpresa=1`,
        "GET"
      );
      setInfo(data[0]);
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };

  const pixelesExtra=()=>{
    const restante=question.length-8;
    
    if(restante>0)
    {            
       return {height:"calc(100vh + " + ((restante/4)*90)+"px)"};
    }

    return {height:"calc(100vh)"};
  }

  return (
    <>
      <Information
        visible={informationToggle.toggle}
        //tipo={user.user.data.Customers.dniType}
        onToggle={informationToggle.onToggle}
        sitio="HB"
      />
      <WhatsappComponent />

      <div className="contenedorBanner contenedorMicrositio" style={!esMovil()?{height:pixelesExtra().height}:{}}>
        <img
          src={slide}
          className="imagenFondoMicrositio"
          onMouseEnter={() => setNovedad(false)}
          alt="Banner Principal"
        ></img>

        

        {/* Bienvenida */}
        <div className="bienvenidaHBMicrositio-movil bienvenidaMICROSITIO-pc fs-1">
          <span>
            {" "}
            Central de Ayuda
          </span>
        </div>

        {/* Buscador */}
        <div className="buscador-container">
          <div className="ayudaHB-pc" style={{marginBottom:"25px"}}>
            <span>¿En qué podemos ayudarte?</span>
          </div>
          <BuscadorComponent />
        </div>

        {/* Atenciòn al público */}
        <div className="atencionMicrositio">
          <span className="text-center-mobile">Búsquedas más frecuentes</span>
        </div>       
        

        {/* Menú grupo */}
        <div className="contenedorGrupoMenu-movil contenedorGrupoMenu-lg contenedorGrupoMenu-xl contenedorGrupoMenuMicrositio-xxl" style={{marginBottom:"0px"}}>        
          <GrupoMenuComponent />
        </div>
      </div>
    </>
  );
};

export default HomeMicrositio;
